var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c(_vm.toolwindow(_vm.tool.tools_id),_vm._b({ref:_vm.tool.text,tag:"component",attrs:{"idprop":((_vm.getToolMasterData(_vm.tool.tools_id).tooldetail.toolId) + "_" + (_vm.tool.tools_id))}},'component',
      Object.assign(
        { tool: _vm.tool },
        { focus: _vm.focus },
        { user: _vm.user },
        { showTracking: _vm.showTracking }
      )
    ,false),[(_vm.focus.state == 'ontrack')?_vm._t("ontrack",[_c('b-container')]):(_vm.focus.state == 'ondeck')?_vm._t("ondeck",[_c('b-container')]):(_vm.focus.state == 'stationed')?_vm._t("stationed",[_c('b-container')]):(_vm.focus.state == 'join')?_vm._t("join",[_c('b-container')]):_vm._t("maintenance",[_c('b-container')])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }